import AgenciesList from 'client/common/components/agencies-list';

import './index.css';

export default AgenciesList;
